// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  font-size: 12px;
  display: block;
  position: static;
}
.modal > .header {
  width: 100%;
  border-bottom: 1px solid gray;
  font-size: 18px;
  text-align: center;
  padding: 5px;
}
.modal > .content {
  width: 100%;
  padding: 10px 5px;
}
.modal > .actions {
  width: 100%;
  padding: 10px 5px;
  margin: auto;
  text-align: center;
}
.modal > .close {
  cursor: pointer;
  position: absolute;
  display: block;
  padding: 2px 5px;
  line-height: 20px;
  right: -10px;
  top: -10px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #cfcece;
}


.d2h-code-linenumber {
  position: relative !important;
}

.d2h-file-switch {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/AddProject.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".modal {\r\n  font-size: 12px;\r\n  display: block;\r\n  position: static;\r\n}\r\n.modal > .header {\r\n  width: 100%;\r\n  border-bottom: 1px solid gray;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  padding: 5px;\r\n}\r\n.modal > .content {\r\n  width: 100%;\r\n  padding: 10px 5px;\r\n}\r\n.modal > .actions {\r\n  width: 100%;\r\n  padding: 10px 5px;\r\n  margin: auto;\r\n  text-align: center;\r\n}\r\n.modal > .close {\r\n  cursor: pointer;\r\n  position: absolute;\r\n  display: block;\r\n  padding: 2px 5px;\r\n  line-height: 20px;\r\n  right: -10px;\r\n  top: -10px;\r\n  font-size: 24px;\r\n  background: #ffffff;\r\n  border-radius: 18px;\r\n  border: 1px solid #cfcece;\r\n}\r\n\r\n\r\n.d2h-code-linenumber {\r\n  position: relative !important;\r\n}\r\n\r\n.d2h-file-switch {\r\n  display: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
